import { jsx as _jsx } from "react/jsx-runtime";
import { useParams } from 'react-router-dom';
import { Box } from '@mui/material';
import palette from '@theme/palette';
import { useSolution, useSolutionMutations, useValidationUiStore } from '@entities/solution';
import { InlineEditText } from './InlineEditText';
export function ResultHeader() {
    const { id: fileId } = useParams();
    const { selectedSolutionId } = useValidationUiStore();
    const { data: solution } = useSolution(fileId, selectedSolutionId);
    const { updateName } = useSolutionMutations(fileId || '', selectedSolutionId);
    if (!solution) {
        return _jsx(Box, { bgcolor: palette.common.white, height: 80 });
    }
    return (_jsx(Box, { bgcolor: palette.common.white, minHeight: 80, alignItems: 'center', display: 'flex', p: 2, children: _jsx(InlineEditText, { value: solution.name, onSave: updateName, typographySx: { fontWeight: 600, fontSize: '20px', color: palette.primary.text } }) }));
}
